export default __webpack_public_path__ + "static/media/66083edbf9a21e03415be2172f5280dd.svg";